import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import man_han_haz_lev from "../img/sswpIcons/ManualHandling/man_han_haz_lev.png";
import man_han_mec_aid from "../img/sswpIcons/ManualHandling/man_han_mec_aid.png";
import man_han_ris_ass from "../img/sswpIcons/ManualHandling/man_han_ris_ass.png";
import man_han_tra from "../img/sswpIcons/ManualHandling/man_han_tra.png";
import man_han_wor_org from "../img/sswpIcons/ManualHandling/man_han_wor_org.png";
import man_han_mul_per_lif from "../img/sswpIcons/ManualHandling/man_han_mul_per.png";
import man_sit_spe_met_sta from "../img/sswpIcons/ManualHandling/man_han_sit_spe_met.png";
import man_han_saf_foo from "../img/sswpIcons/ManualHandling/man_han_saf_foo.png";
const json = {
    icon: man_han_haz_lev,
    name: "Manual Handling",
    text:
        "Manual Handling is the physical movement by a person of objects by lifting, pushing or pulling, that is likely to cause injury or other health problems.",
    icons: {
        man_han_tra: {
            name: "Training",
            icon: man_han_tra,
            text: (
                <ul>
                    <ListItem text="Manual handling training is a legal requirement for anyone required to carry out manual handling operations at work." />
                    <ListItem text="In confined spaces all persons working, supervising, planning, implementing the safe system of work, or participating in a rescue will require adequate instruction and/or training. The complexity of the task will determine the level of training required." />
                    <ListItem text="Adequate supervision, by a person who has the authority to issue instructions, is essential to ensure the activity is completed as planned. For higher risk activities, this will require the person to be present on site during the activity. Workers, under supervision, should be fully informed and have a complete understanding of the potential hazards and the safe working system to be used." />
                    <ListItem text="Workers need to have the physical capability to undertake the task, within the work environment. They need to be fit for the work concerned." />
                    <ListItem text="Before a tool or piece of plant is used it must be checked for it’s suitability for the task, e.g. capacity, capability, safe working load etc." />
                </ul>
            )
        },
        man_han_ris_ass: {
            name: "Risk Assess",
            icon: man_han_ris_ass,
            text: (
                <ul>
                    <ListItem text="Every work activity needs to be risk assessed prior to commencing. Identify potential hazards. Assess the likelihood of something happening, and the severity if something did go wrong. Select appropriate controls that will be put in place before the activity begins." />
                </ul>
            )
        },
        man_han_wor_org: {
            name: "Work Organisation",
            icon: man_han_wor_org,
            text: (
                <ul>
                    <ListItem text="Organise work to eliminate or reduce the need for manual handling" />
                    <ListItem text="Use automation and lifting equipment" />
                    <ListItem text="Organise manual handling tasks in a safe way, with loads split into smaller ones, and proper rest periods provided" />
                    <ListItem text="Plan the task, organising how equipment is to be used and the correct handling techniques that are going to be used" />
                    <Li>
                        <Typography variant="title">
                            Assess the load for the following risks, and plan
                            accordingly
                        </Typography>
                        <ol>
                            <ListItem text="Heavy" />
                            <ListItem text="Large" />
                            <ListItem text="Difficult to grasp" />
                            <ListItem text="Unbalanced or unstable" />
                            <ListItem text="Difficult to reach" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Assess the task for the following risks, and plan
                            accordingly
                        </Typography>
                        <ol>
                            <ListItem text="Strenuous (too frequent, or too long without sufficient rest periods)" />
                            <ListItem text="Involving awkward movements or postures" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Assess the environment for the following risks, and
                            plan accordingly
                        </Typography>
                        <ol>
                            <ListItem text="Sufficient space" />
                            <ListItem text="Floor (level, slope, slippy)" />
                            <ListItem text="Weather (heat, sweat)" />
                            <ListItem text="Lighting" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Assess the individuals involved in the operation,
                            and plan accordingly
                        </Typography>
                        <ol>
                            <ListItem text="Experience and training" />
                            <ListItem text="Age" />
                            <ListItem text="Physical dimensions and capacity (team up with similar abilities)" />
                            <ListItem text="History of back disorders" />
                            <ListItem text="Use of PPE" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        man_han_saf_foo: {
            name: "Safe Footing / Rough Ground",
            icon: man_han_saf_foo,
            text: (
                <ul>
                    <ListItem text="Assess ground conditions for walking on." />
                    <ListItem text="The ground may need to be prepared, e.g. levelled/rolled to make it suitable." />
                    <ListItem text="You should wear appropriate footwear with suitable ankle support." />
                    <ListItem text="All surfaces being walked on must have adequate lighting conditions/illumination." />
                </ul>
            )
        },
        man_han_mec_aid: {
            name: "Mechanical Aids",
            icon: man_han_mec_aid,
            text: (
                <ul>
                    <ListItem text="Should be provided and used to eliminate, or assist, manual handling. They include powered vehicles and equipment, to handheld tools/ trolleys." />
                    <ListItem text="Aids should be CE marked and have the required safe working load." />
                    <ListItem text="Working areas and methods should be planned to maximise the use of these aids." />
                </ul>
            )
        },

        man_han_mul_per: {
            name: "Multi-Person Lift",
            icon: man_han_mul_per_lif,
            text: (
                <ul>
                    <ListItem text="All operatives involved must have received manual handling training. Only carry what you are comfortable with." />
                    <ListItem text="Operatives should generally be of similar size, to ensure a balanced load. Plan the hold positions so that the load is evenly balanced across all operatives. Ensure hold positions are secure and capable of bearing the weight." />
                    <ListItem text=" Before the lift, agree on one operative to be the lead operative to ensure control and coordinated action." />
                    <ListItem text="Ensure you have enough space (free from obstruction) for the load and each person involved to carry out the necessary range of movements." />
                    <Li>
                        <Typography variant="title">
                            Recommended Checks
                        </Typography>
                        <ol>
                            <ListItem text="Take a balanced stance with feet about shoulder width apart" />
                            <ListItem text="Squat, but keep your heels off the floor. Get as close as you can to the object. Use your legs NOT your back." />
                            <ListItem text="Use your palms, not just fingers to get a secure grip" />
                            <ListItem text="Use smooth motions. Do not jerk. Do not twist when changing direction" />
                            <ListItem text="Keep an eye on where you are placing your feet during the move. Point your feet in the direction of movement" />
                        </ol>
                    </Li>
                    <ListItem text="Wear gloves to avoid injury, contact injuries and to provide adequate grip. Wear non-slip footwear to provide sure footing." />
                </ul>
            )
        },
        man_sit_spe_met: {

            name: "Site Specific Method Statement/Design",

            icon: man_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
